import { Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { AsyncValidatorFn, FormBuilder, FormControl, FormGroup, ValidatorFn, Validators } from '@angular/forms';
import CustomStore from 'devextreme/data/custom_store';
import DataSource from 'devextreme/data/data_source';
import { alert } from 'devextreme/ui/dialog';
import notify from 'devextreme/ui/notify';
import { NgxSpinnerService } from 'ngx-spinner';
import { Subject, Subscription } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { Apiservice } from '../../services/api.service';
import { Sede } from '../../views/gestione-formulari/interfaces';
import { Soggetto } from '../popup-gestione-fir-digitali/interfaces';
import { ComponentService } from '../../services/component.service';
import { AnaColumn } from '../../services/forms-template.service';
import { DxButtonComponent, DxRadioGroupComponent } from 'devextreme-angular';

export interface QRCodeData {
  header: "RENTRI"
  type: "BoardingId"
  codiceFiscale: string
  numIscrOperatore: string
  numIscrSito: string
  data: string
  pin: string
  nomeCognome: string
  tipo: string;
}
export interface BoardingInfoResponse {
  versione: number
  id: number
  idSoggetto: number
  codiceFiscale: string
  denominazioneSoggetto: string
  numIscrOperatore: string
  numIscrSito: string
  nomeSito: string
  tokenQRCode: string
  pin: string
  dataOraCreazione: string
  nomeCognome: string
  tipo: string
}
@Component({
  selector: 'app-associa-dispositivo',
  templateUrl: './associa-dispositivo.component.html',
  styleUrls: ['./associa-dispositivo.component.css']
})
export class AssociaDispositivoComponent implements OnInit, OnDestroy {
  @ViewChild('btnLista', { static: false }) btnLista: DxButtonComponent
  @ViewChild('btnQrCode', { static: false }) btnQrCode: DxButtonComponent
  @ViewChild('btnNew', { static: false }) btnNew: DxButtonComponent
  @ViewChild('tipoFirmaRadio', { static: false }) tipoFirmaRadio: DxRadioGroupComponent
  @Input() soggetto: Soggetto | undefined
  @Input() unita_locale: Sede | null = null
  passwordMode: 'password' | 'text' = 'password';
  passwordButton = {
    icon: 'bi bi-eye',
    stylingMode: 'text',
    onClick: () => this.passwordMode = this.passwordMode === 'text' ? 'password' : 'text'
  };
  qrdata: string
  tipoFirma: '1' | '2' | undefined
  protected formGroups: FormGroup = this.fb.group({})
  protected fields: Record<string, {
    label: string;
    value: any,
    validators: ValidatorFn[];
    asyncValidators: AsyncValidatorFn[];
    disabled: boolean;
    items?: {
      dataSource?: DataSource | any[];
      displayExpr?: string | ((item: any) => string);
      valueExpr?: string | ((item: any) => string);
    }
  }>
  private destroy$ = new Subject<void>();
  constructor(private readonly fb: FormBuilder, private readonly Apiservice: Apiservice, private readonly loader: NgxSpinnerService, private readonly componentService: ComponentService) { }
  ngOnDestroy(): void {
    this.destroy$.next()
    this.destroy$.complete()
  }

  ngOnInit() {
    this.processFormGroup()
    this.formGroups.valueChanges
      .pipe(takeUntil(this.destroy$))
      .subscribe(value => {
        console.log(value)
      });
  }
  blockInput(e: any) {
    e.event.preventDefault();
  }

  hasError(fieldKey: string): boolean {
    const control = this.formGroups.get(fieldKey);
    if (!control) return false;
    if (!control.touched) return false;
    return control.invalid;
  }
  getValue(field: string): any | null {
    if (!this.formGroups.get(field)) return null
    const campo = this.formGroups.get(field)
    if (!campo) return null
    return campo.value;
  }
  onDxChange(field: string, event: any) {
    const control = this.formGroups.get(field)
    if (!control) return
    control.setValue(event.value)
    this.formGroups.updateValueAndValidity()
    if (field === 'soggetto') {
      this.onSoggettoChange(event.value);
    }
    if (field === 'unita_locale') {
      this.onUlChange(event.value);
    }
    if (field === 'tipoFirma') {
      this.onTipoFirmaChange(event.value);
    }
  }
  async onSubmit() {
    this.formGroups.markAllAsTouched()
    if (this.formGroups.invalid) {
      const msg = []
      for (const [field, ctrl] of Object.entries(this.formGroups.controls)) {
        if (ctrl.invalid) msg.push(`<p class="m-0 mb-2">${this.getErrorMessage(field)}</p>`);
      }
      if (msg.length > 0) alert(msg.join(''), 'Attezione');
    } else {
      // console.log('submit') 
      return await this.generaQr()
    }
  }
  apriLista() {
    if (!this.tipoFirma) return;
    const queryString = this.tipoFirma === '2' ? '' : '?includiUtentiNonAssociatiAdAzienda=true'
    const sede = this.formGroups.get('unita_locale').value
    if (!sede) return;
    const dataSource = this.tipoFirma === '2' ? `Autista/${sede.id}` : 'Account'
    const filterStatic = this.tipoFirma === '2' ? '' : '$filter=((tipoutente gt 2)and(sospeso eq false))'
    let colonne = []
    if (this.tipoFirma === '2') {
      colonne = [
        {
          dataField: 'id',
          dataType: '',
          caption: 'Codice',
          allowEditing: true,
          colVisible: false
        },
        {
          dataField: 'nome',
          dataType: '',
          caption: 'Nome',
          allowEditing: true,
        },
        {
          dataField: 'cognome',
          dataType: '',
          caption: 'Cognome',
          allowEditing: true,
        },
        {
          dataField: 'matricola',
          dataType: '',
          caption: 'Matricola',
          allowEditing: true,
        },
      ]
    } else {
      colonne = [
        {
          dataField: 'id',
          dataType: '',
          caption: 'Codice',
          allowEditing: true,
          colVisible: false
        },
        {
          dataField: 'nome',
          dataType: '',
          caption: 'Nome',
          allowEditing: true,
        },
        {
          dataField: 'cognome',
          dataType: '',
          caption: 'Cognome',
          allowEditing: true,
        },
        {
          dataField: 'userName',
          dataType: '',
          caption: 'Username',
          allowEditing: true,
        },
      ]
    }
    const data = {
      dynamic: {
        queryString,
        dataSource,
        caption: `Lista ${this.formGroups.get('tipoFirma').value === '1' ? 'Operatori' : 'Autisti'}`,
        filterStatic,
        componentType: 'dynamicGrid',
        settingGrid: {
          masterKey: 'id',
          keyUnique: '',
          wingap: true,
          mode: 'cell',
          selectionMode: 'single',
          remoteOperations: true,
          hoverStateEnabled: true,
          rowAlternationEnabled: true,
          repaintChangesOnly: true,
          showFilterSearch: false,
          allowUpdating: false,
          allowDeleting: false,
          allowAdding: false,
          height: 630,
          showColBlank: false,
          campoTabRif: '',
          searchAndSelect: true, //Cerca Valore e seleziona
          searchType: 'contains',
          width: 900,
          toolbarButtonsBottomLeft: null,
          toolbarButtonsBottomRight: [0],
          isOdata: true,
          overrideDataSource: null,
          concatDataField: null,
          colonne
        },
      },
    }
    return this.openComponentGrid(data)
  }
  reset() {
    this.formGroups.reset()
    this.formGroups.markAsUntouched()
    this.qrdata = undefined
    this.btnQrCode.disabled = false
    this.btnNew.disabled = true
    this.formGroups.get('soggetto').setValue(this.soggetto)
    this.formGroups.get('unita_locale').setValue(this.unita_locale)
  }
  //!-----------------------------------------------------------------------------------------------------------
  private async generaQr() {
    this.loader.show()
    const res = (msg: string, status: 'success' | 'error') => {
      return notify({
        message: msg,
        width: 300,
        position: 'center center'
      }, status, 6000);
    }
    try {
      const NumIscrSito = this.formGroups.getRawValue()['unita_locale']['idSedeRentri']
      const boardingInfo = await this.Apiservice.GetApi(`BoardingInfoRentri/GetLastByNumSito/${NumIscrSito}`) as BoardingInfoResponse
      console.log(boardingInfo)
      if (!boardingInfo) alert('Generazione QR code fallita. Riprovare o contattare l\'assistenza', 'Attenzione');
      this.formGroups.get('pin').setValue(boardingInfo.pin)
      this.formGroups.updateValueAndValidity()
      const nome = this.formGroups.get('nome').value
      if (!nome) return res('Generazione QR code fallita. Riprovare o contattare l\'assistenza', 'error');
      const cognome = this.formGroups.get('cognome').value
      if (!cognome) return res('Generazione QR code fallita. Riprovare o contattare l\'assistenza', 'error');
      const tipo = this.formGroups.get('tipoFirma').value
      if (!tipo) return res('Generazione QR code fallita. Riprovare o contattare l\'assistenza', 'error');
      const nomeCognome = `${nome} ${cognome}`
      const qrData: QRCodeData = {
        header: 'RENTRI',
        type: 'BoardingId',
        codiceFiscale: boardingInfo.codiceFiscale,
        nomeCognome,
        numIscrOperatore: boardingInfo.numIscrOperatore,
        numIscrSito: boardingInfo.numIscrSito,
        pin: boardingInfo.pin,
        tipo,
        data: boardingInfo.tokenQRCode
      }
      console.log(qrData)
      this.qrdata = JSON.stringify(qrData)
      this.formGroups.disable()
      this.btnLista.disabled = true
      this.btnQrCode.disabled = true
      this.btnNew.disabled = false
      return res('Generazione QR code effettuata con successo.', 'success')
    } catch {
      return res('Generazione QR code fallita. Riprovare o contattare l\'assistenza', 'error')
    } finally {
      this.loader.hide()
      return
    }
  }
  private onSoggettoChange(dest: Soggetto) {
    if (dest && dest.id) {
      this.fields['unita_locale'].disabled = false
      this.formGroups.get('unita_locale').enable()
      this.fields['unita_locale'].items.dataSource = this.createDataSource(`Sede/${dest.id}`, 'id', 'descrizione', '', 10, true, dest)
    } else {
      this.fields['unita_locale'].disabled = true
      this.formGroups.get('unita_locale').disable()
      this.fields['unita_locale'].items.dataSource = []
    }
    this.formGroups.get('unita_locale').setValue(null);
    this.formGroups.get('unita_locale').updateValueAndValidity();
  }

  private onUlChange(ul: Sede) {
    if (ul && ul.id) {
      if (ul.isTrasportatore) {
        this.fields['tipoFirma'].disabled = false
        this.formGroups.get('tipoFirma').enable()
        this.formGroups.get('tipoFirma').setValue(null);
      } else {
        this.fields['tipoFirma'].disabled = true
        this.formGroups.get('tipoFirma').disable()
        this.formGroups.get('tipoFirma').setValue('1');
      }

    } else {
      this.fields['tipoFirma'].disabled = true
      this.formGroups.get('tipoFirma').disable()
      this.formGroups.get('tipoFirma').setValue(null);
    }
    this.formGroups.get('tipoFirma').updateValueAndValidity();
  }
  private onTipoFirmaChange(tipoFirma: '1' | '2') {
    this.tipoFirma = tipoFirma
    if (tipoFirma) {
      this.fields['cognome'].disabled = false
      this.formGroups.get('cognome').enable()
      this.fields['nome'].disabled = false
      this.formGroups.get('nome').enable()

    } else {
      this.fields['cognome'].disabled = true
      this.formGroups.get('cognome').disable()
      this.fields['nome'].disabled = true
      this.formGroups.get('nome').disable()
    }
    this.formGroups.get('cognome').setValue(null);
    this.formGroups.get('cognome').updateValueAndValidity();
    this.formGroups.get('nome').setValue(null);
    this.formGroups.get('nome').updateValueAndValidity();
  }

  private getErrorMessage(field: string): string | null {
    const control = this.formGroups.get(field);
    if (!control || !control.errors) return null;
    const errors = control.errors;
    const fallbackMessages: Record<string, (err: any) => string> = {
      required: () => `Campo ${this.fields[field].label} obbligatorio`,
      minlength: err => `Campo ${this.fields[field].label} minimo ${err.requiredLength} caratteri`,
      maxlength: err => `Campo ${this.fields[field].label} massimo ${err.requiredLength} caratteri`,
      min: err => `Campo ${this.fields[field].label} valore minimo ${err.min}`,
      max: err => `Campo ${this.fields[field].label} valore massimo ${err.max}`,
      pattern: () => `Campo ${this.fields[field].label} non valido`,
      custom: err => typeof err === 'string' ? err : `${this.fields[field].label} non valido`,
      async: err => typeof err === 'string' ? err : `${this.fields[field].label} non valido`,
    };
    for (const key of Object.keys(errors)) {
      const err = errors[key];
      if (fallbackMessages[key]) return fallbackMessages[key](err);
    }
    return `Campo non valido`;
  }

  private processFormGroup() {
    this.processFieldsMetadata()
    for (const [field, ctrl] of Object.entries(this.fields)) {
      this.formGroups.addControl(field, new FormControl(
        { value: ctrl.value, disabled: ctrl.disabled },
        { validators: ctrl.validators, asyncValidators: ctrl.asyncValidators, updateOn: 'submit' }));
    }
    this.tipoFirma = this.unita_locale !== null ? this.unita_locale.isTrasportatore === true ? null : '1' : null
  }

  private processFieldsMetadata() {
    this.fields = {
      soggetto: {
        label: 'Soggetto',
        value: this.soggetto,
        validators: [Validators.required],
        asyncValidators: [],
        disabled: true,
        items: {
          dataSource: this.createDataSource('Soggetto', 'id', 'ragioneSociale', 'NostreAziende=S', 10, false, undefined),
          displayExpr: 'ragioneSociale',
          valueExpr: null,
        },
      },
      unita_locale: {
        label: 'U.L',
        value: this.unita_locale,
        validators: [Validators.required],
        disabled: typeof this.soggetto === 'undefined',
        asyncValidators: [],
        items: {
          dataSource: typeof this.soggetto !== 'undefined' ? this.createDataSource(`Sede/${this.soggetto.id}`, 'id', 'descrizione', '', 10, true, this.soggetto) : [],
          displayExpr: 'descrizione',
          valueExpr: null,
        }
      },
      tipoFirma: {
        label: 'Tipo Firma',
        value: this.unita_locale !== null ? this.unita_locale.isTrasportatore === true ? null : '1' : null,
        validators: [Validators.required],
        disabled: this.unita_locale === null ? true : this.unita_locale.isTrasportatore === true ? false : true,
        asyncValidators: [],
        items: {
          dataSource: [{ value: '1', label: 'Operatore', disabled: false }, { value: '2', label: 'Autista', disabled: false },],
          displayExpr: 'label',
          valueExpr: 'value',
        }
      },
      cognome: {
        label: 'Cognome',
        value: null,
        validators: [Validators.required],
        asyncValidators: [],
        disabled: this.unita_locale === null ? true : this.unita_locale.isTrasportatore !== true ? false : true,
      },
      nome: {
        label: 'Nome',
        value: null,
        validators: [Validators.required],
        asyncValidators: [],
        disabled: this.unita_locale === null ? true : this.unita_locale.isTrasportatore !== true ? false : true,
      },
      pin: {
        label: 'Pin',
        value: null,
        validators: [],
        asyncValidators: [],
        disabled: true,
      },
    }
  }
  private createDataSource(
    endpoint: string,
    keyField: string = 'id',
    displayField: string | string[] = 'id',
    filterPart: string = '',
    pageSize: number = 10,
    isPreCheck: boolean = false,
    chechkValue?: any,
    transformFn?: (items: any[]) => any[],
  ) {
    return new DataSource({
      store: new CustomStore({
        key: keyField,
        load: async (loadOptions: any) => {
          if (isPreCheck && !chechkValue) return { data: [], totalCount: 0 };
          try {
            const skip = loadOptions.skip || 0;
            const take = loadOptions.take || pageSize;
            let currentFilterPart = '&' + filterPart.replace('?', '');
            if (loadOptions.searchValue && loadOptions.searchValue.trim() !== '') {
              const s = loadOptions.searchValue.trim().toLowerCase();

              if (!Array.isArray(displayField)) {
                if (currentFilterPart.includes('$filter=')) {
                  currentFilterPart = currentFilterPart.replace(
                    '$filter=',
                    `$filter=contains(tolower(${displayField}), '${s}') and `
                  );
                } else {
                  currentFilterPart += `&$filter=contains(tolower(${displayField}), '${s}')`;
                }
              } else {
                displayField.forEach((val) => {
                  if (currentFilterPart.includes('$filter=')) {
                    currentFilterPart = currentFilterPart.replace(
                      '$filter=',
                      `$filter=contains(tolower(${val}), '${s}') and `
                    );
                  } else {
                    currentFilterPart += `&$filter=contains(tolower(${val}), '${s}')`;
                  }
                })
              }
            }
            const url =
              `${endpoint}?$skip=${skip}&$top=${take}&$count=true` +
              currentFilterPart;
            const res: any = await this.Apiservice.GetApi(url);
            let items = res.items || [];
            if (transformFn) items = transformFn(items);
            return {
              data: items,
              totalCount: res.totalCount || 0,
            };
          } catch (e) {
            console.error("Errore load generic", e);
            throw e;
          }
        },

        byKey: async (key: any) => {
          if (isPreCheck && !chechkValue) return null;
          if (key === null || key === undefined || key === '' || key === 0) return null;
          try {
            const url = (() => {
              const partKey = typeof key === 'string' ? `'${key}'` : `${key}`
              const filters: string[] = [];
              const m = filterPart.match(/\$filter=(.*)/);
              if (m) filters.push(`(${m[1]})`);
              filters.push(`${keyField} eq ${partKey}`);
              filterPart = filterPart.split('$filter=')[0].replace(/&$/, '')
              return `${endpoint}?${filterPart}&$filter=${filters.join(' and ')}`
            })();
            const res: any = await this.Apiservice.GetApi(url);
            let items = res.items || [];
            if (transformFn) items = transformFn(items);
            return items[0] || null;
          } catch (e) {
            console.error("Errore byKey generic", e);
            throw e;
          }
        },
      }),
      paginate: true,
      pageSize,
      searchExpr: displayField,
    });
  }
  private openComponentGrid(data) {
    const instancedDataGrid = {
      service: data.dynamic.service,
      api: data.dynamic.dataSource,
      api_rest: data.dynamic.api_rest,
      remoteOperation: data.dynamic.settingGrid.remoteOperations,
      rowAlternate: true,
      dataJson: {},
      queryString: data.dynamic.queryString,
      filterStatic: data.dynamic.filterStatic,
      isEditable: false,
      isEditableNewRow: false,
      isEditableEditRow: false,
      isEditableDeleteRow: false,
      tableHeight: data.dynamic.settingGrid.height,
      tableWidth: data.dynamic.settingGrid.width,
      showFilter: data.dynamic.settingGrid.showFilterSearch,
      searchType: data.dynamic.settingGrid.searchType,
      colonne: data.dynamic.settingGrid.colonne,
      selectionRowMode: data.dynamic.settingGrid.selectionMode,
      selectedData: [],
      overrideDataSource: null,
      showCaptionFooter: false,
      showCaptionHeader: true,
      isOdata: data.dynamic.settingGrid.isOdata,
      idTable: Math.random().toString().replace("0.", ""),
      showToolbarTop: false,
      showToolbarBottom: true,
      toolbarButtonsTopLeft: data.dynamic.settingGrid.toolbarButtonstopLeft,
      toolbarButtonsTopRight: data.dynamic.settingGrid.toolbarButtonsTopRight,
      toolbarButtonsBottomLeft: data.dynamic.settingGrid.toolbarButtonsBottomLeft,
      toolbarButtonsBottomRight: data.dynamic.settingGrid.toolbarButtonsBottomRight,
      isSearchable: data.dynamic.settingGrid.searchAndSelect,
      detailOptions: null,
      customNewRowBtn: data.dynamic.settingGrid.customNewRowBtn || 'Nuovo'
    }
    let guid = Math.random().toString().replace("0.", "")
    this.componentService.setNewPopUp(guid, 'NicaDataGridComponent', null, data.dynamic.settingGrid.width, data, instancedDataGrid, false, true, data.dynamic.caption);
    const sub: Subscription = this.componentService.outputComponent.subscribe(currentOutput => {
      if (currentOutput.guid === guid) {
        if (currentOutput.name === "onRowSelectionChange") {
          const dataSelect = currentOutput.data
          if (!dataSelect) return;
          this.formGroups.get('nome').setValue(dataSelect.nome)
          this.formGroups.get('cognome').setValue(dataSelect.cognome)
          this.componentService.destroyCurrentOpenPopUpByGuid(guid)
          sub.unsubscribe()
        }
        if (currentOutput.name === "annullaSelezione") { this.componentService.destroyCurrentOpenPopUpByGuid(guid); sub.unsubscribe() }
      }
    })
  }

}
